import {Marked} from 'marked';

import {processAllTokens} from './processAllTokens';

import {tokenizer} from './tokenizer';
import {mentionExtension} from './extensions/mentions';
import {emojiExtension, unicodeEmojiExtension} from './extensions/emoji';
import {extendedBr} from './extensions/extended-br';
import {inlineLatexExtension} from './extensions/inline-latex';

const marked = new Marked({
    extensions: [extendedBr, emojiExtension, mentionExtension, unicodeEmojiExtension, inlineLatexExtension],
    hooks: {
        processAllTokens,
    },
    tokenizer,
});

export type {Tokens} from 'marked';
export type {MarkedOptions} from 'marked';

export {Renderer} from 'marked';
export * from './utils';

export default marked;
